import posthog from "posthog-js";

const DENYLISTED_KEYS = new Set([
  "email",
  "name",
  "prompt",
  "caption",
  "content",
  "text",
  "body",
  "output",
  "brand_voice",
  "brand_profile",
  "helper_notes",
  "business",
  "company",
  "audience",
  "keywords",
  "summary",
  "style_rules",
  "negative_prompt",
  "banned_phrases",
  "sample_phrases",
  "avoid_phrases",
]);

const MAX_STRING_LENGTH = 120;

function sanitize(props) {
  if (!props || typeof props !== "object") return {};

  const safe = {};
  for (const [key, value] of Object.entries(props)) {
    if (DENYLISTED_KEYS.has(key)) continue;

    if (typeof value === "string") {
      safe[key] =
        value.length > MAX_STRING_LENGTH
          ? value.slice(0, MAX_STRING_LENGTH)
          : value;
    } else if (
      value === null ||
      typeof value === "number" ||
      typeof value === "boolean"
    ) {
      safe[key] = value;
    }
    // Drop everything else (objects, arrays, functions, undefined).
    // Analytics events should never carry rich payloads — they could leak
    // user content by accident.
  }
  return safe;
}

export function safeCapture(event, props = {}) {
  try {
    if (typeof window === "undefined") return;
    if (!posthog || typeof posthog.capture !== "function") return;
    if (!posthog.__loaded) return;

    posthog.capture(event, sanitize(props));
  } catch {
    // Never let analytics break the app.
  }
}
